import React from 'react';

import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type Props = {
  open: boolean;
  submitting?: boolean;
  onReload: () => void;
};

/**
 * 保存/リバートの version 不一致（422）通知ダイアログ。
 * 「最新を取得」でファイル詳細を再取得する。
 */
const ConflictDialog: React.FC<Props> = ({ open, submitting, onReload }) => {
  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="xs"
      slotProps={{
        paper: {
          elevation: 0,
          sx: { borderRadius: 3, border: 1, borderColor: 'divider' },
        },
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <WarningAmberIcon sx={{ color: 'warning.main' }} />
          <Typography variant="subtitle1" fontWeight={600}>
            保存できませんでした
          </Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          他のユーザーがこのファイルを更新しました。最新の内容を取得します。
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          variant="contained"
          onClick={onReload}
          disabled={submitting}
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            boxShadow: 'none',
            '&:hover': { boxShadow: 'none' },
          }}
        >
          最新を取得
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConflictDialog;
